// aos js
AOS.init({
    duration: 1200,
});
// mobile version
AOS.init({ disable: 'mobile' });
AOS.init({
    disable: function () {
        var maxWidth = 1200;
        return window.innerWidth < maxWidth;
    }
});

Fancybox.bind('[data-fancybox="gallery"]', {
    // Your custom options for a specific gallery
});

$('.announcement-track').owlCarousel({
    loop: true,
    margin: 0,
    nav: true,
    dots: false,
    autoplay: true,
    center: true,
    items: 5,
    navText: ['<i class="fa-solid fa-arrow-left"></i>', '<i class="fa-solid fa-arrow-right"></i>'],
    autoplayTimeout: 6000,
    autoplaySpeed: 2000,
    smartSpeed: 2000,
    autoplayHoverPause: false,
    responsiveClass: true,
    responsive: {
        0: { items: 1, center: false },
        576: { items: 2, center: false },
        767: { items: 2, center: false },
        992: { items: 3 },
        1200: { items: 5 },
        1400: { items: 5 },
        1600: { items: 5 },
    },

});

// function updateGalleryClasses() {
//     const slider = $('.gallery-slider');

//     // Remove previous custom classes
//     slider.find('.owl-item').removeClass('prev-center next-center first-active last-active');

//     const centerItem = slider.find('.owl-item.active.center');

//     // Target item just BEFORE center
//     centerItem.prev('.owl-item').addClass('prev-center');

//     // Target item just AFTER center
//     centerItem.next('.owl-item').addClass('next-center');

//     // Target first and last active items
//     const activeItems = slider.find('.owl-item.active');
//     activeItems.first().addClass('first-active');
//     activeItems.last().addClass('last-active');
// }

// $('.owl-carousel').on('changed.owl.carousel', function () {

//     $('.owl-item').removeClass('prev-center next-center');

//     var center = $('.owl-item.center');

//     center.prev().addClass('prev-center');
//     center.next().addClass('next-center');

// });

$('.gallery-video-carousel').owlCarousel({
    loop: true,
    center: true,
    items: 3,
    margin: 24,
    nav: true,
    dots: false,
    autoplay: false,
    smartSpeed: 700,
    autoHeight: false,
    navText: ['<i class="fa-solid fa-arrow-left"></i>', '<i class="fa-solid fa-arrow-right"></i>'],
    responsive: {
        0: {
            items: 1,
            // margin: 14,
            center: false,
            // stagePadding: 20
        },
        576: {
            items: 1,
            margin: 18,
            center: false,
            // stagePadding: 60
        },
        768: {
            items: 3,
            margin: 20,
            center: false
        },
        1200: {
            items: 3,
            // margin: 24,
            center: true
        }
    },
    // Add these two callbacks
    // onInitialized: updateGalleryClasses,
    // onTranslated: updateGalleryClasses
});
$('.product-slider').owlCarousel({
    loop: true,
    margin: 20,
    nav: true,
    dots: false,
    autoplay: false,
    smartSpeed: 700,
    navText: ['<i class="fa-solid fa-arrow-left"></i>', '<i class="fa-solid fa-arrow-right"></i>'],
    responsive: {
        0: {
            items: 1,
        },
        576: {
            items: 1,
        },
        768: {
            items: 2,
        },
        1000: {
            items: 1,
        },
        1200: {
            items: 1,
        },
        1400: {
            items: 2,
        }
    },
    // Add these two callbacks
    // onInitialized: updateGalleryClasses,
    // onTranslated: updateGalleryClasses
});
$('.partner-slider').owlCarousel({
    loop: true,
    margin: 20,
    nav: true,
    dots: false,
    autoplay: false,
    smartSpeed: 700,
    navText: ['<i class="fa-solid fa-arrow-left"></i>', '<i class="fa-solid fa-arrow-right"></i>'],
    responsive: {
        0: {
            items: 2,
        },
        576: {
            items: 4,
        },
        768: {
            items: 4,
        },
        1200: {
            items: 6,
        }
    },
    // Add these two callbacks
    // onInitialized: updateGalleryClasses,
    // onTranslated: updateGalleryClasses
});

$(document).ready(function () {

    $(window).scroll(function () {
        if ($(window).scrollTop() >= 100) {
            $('.navbar').addClass('header-fixed');
        }
        else {
            $('.navbar').removeClass('header-fixed');
        }
    });
    // animate();
});
